<ng-container *transloco="let tr; prefix: 'productDefinitions'; scope: 'product-definitions'">
  <nz-page-header [nzGhost]="false">
    <nz-page-header-title>{{tr('split-list.title')}}</nz-page-header-title>
    <nz-page-header-extra>
      <a [routerLink]="['split', 'new']" nz-button nzType="primary">
        <i nz-icon nzType="plus-circle" nzTheme="outline"></i> {{'button.addNew' | transloco}}
      </a>
    </nz-page-header-extra>
  </nz-page-header>

  <nz-table [nzLoading]="isTableLoading" #listTable
            [nzTotal]="total"
            [nzPageSize]="limit"
            [nzPageIndex]="page"
            [nzData]="list"
            (nzQueryParams)="onQueryParamsChange($event)"
            [nzFrontPagination]="false">
    <thead>
    <tr>
      <th>{{tr('column.inProductInfo')}}</th>
      <th>{{tr('column.outProductInfo')}}</th>
      <th>{{tr('column.splitQuantity')}}</th>
      <th>{{tr('column.shape')}}</th>
      <th>{{tr('column.productSize')}}</th>
      <th nzWidth="100px">#</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of listTable.data">
      <td>{{ data.inProductInfo.title | uiLabel }}</td>
      <td>{{ data.outProductInfo.title | uiLabel }}</td>
      <td>{{ data.splitQuantity }}</td>
      <td>{{ tr('shape.' + data.shape) }}</td>
      <td>{{ data.inProductSize }}</td>
      <td>
        <nz-button-group>
          <a [routerLink]="['split', data.id, 'edit']" nz-button nzType="primary">
            <i nz-icon nzType="edit" nzTheme="outline"></i>
          </a>
          <button nz-button nzType="default" nzDanger nz-popconfirm
                  [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                  [nzCancelText]="'no1' | transloco"
                  (nzOnConfirm)="remove(data.id)">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
          </button>
        </nz-button-group>
      </td>
    </tr>
    </tbody>
  </nz-table>

</ng-container>
